module.exports = __webpack_public_path__ + "static/media/Example of Jobs.8744728e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Example of Jobs.csv
// module id = 764
// module chunks = 0